<template>
  <div>
    <div>
      <div class="vx-col w-full">
        <vx-card :title=" userInfo.suffix +' - '+ 'Showroom Dashboard'">
          <vs-tabs :color="colorx">
            <vs-tab @click="colorx = 'success'" label="New Application">
              <div class="con-tab-ejemplo">
                <ApplicationList></ApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'dark'" label="In Progress Application">
              <div class="con-tab-ejemplo">
                <InProgressApplicationList></InProgressApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'warning'" label="Halt Application">
              <div class="con-tab-ejemplo">
                <HaltApplicationList></HaltApplicationList>
              </div>
            </vs-tab>

            <!--<vs-tab @click="colorx = 'success'" label="Accepted Application">
              <div class="con-tab-ejemplo">
                <AcceptedApplicationList></AcceptedApplicationList>
              </div>
            </vs-tab>-->

            <vs-tab @click="colorx = 'rgb(233,43,55)'" label="Pending">
              <div class="con-tab-ejemplo">
                <PendingForSubmittedApplicationList></PendingForSubmittedApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'rgb(233,43,55)'" label="Submitted">
              <div class="con-tab-ejemplo">
                <SubmittedApplicationList></SubmittedApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'rgb(233,43,55)'" label="Rejected Application">
              <div class="con-tab-ejemplo">
                <RejectedtedApplicationList></RejectedtedApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'rgb(233,43,55)'" label="Search Application">
              <div class="con-tab-ejemplo">
                <SearchApplicationList></SearchApplicationList>
              </div>
            </vs-tab>

            <vs-tab @click="colorx = 'rgb(233,43,55)'" :label="'Change Request'+' - '+ '['+(allChangeReqAppl.total+']')">
              <div class="con-tab-ejemplo">
                <ChangeApplLists></ChangeApplLists>
              </div>
            </vs-tab>
            <!--<vs-tab @click="colorx = 'success'" label="Reviewed Application">
              <div class="con-tab-ejemplo">
                <ReviewedApplicationList></ReviewedApplicationList>
              </div>
            </vs-tab>-->
          </vs-tabs>

        </vx-card>
      </div>
    </div>

    <!--<Guarantor></Guarantor>-->

  </div>
</template>
<script>
  import Guarantor from './pages/Guarantor.vue'
  import ApplicationList from './pages/ApplicationList.vue'
  import InProgressApplicationList from './pages/InProgressApplicationList'
  import HaltApplicationList from './pages/HaltApplicationList'
  import AcceptedApplicationList from './pages/AcceptedApplicationList'
  import RejectedtedApplicationList from './pages/RejectedApplicationList'
  import SearchApplicationList from './pages/SearchApplicationList'
  import PendingForSubmittedApplicationList from './pages/PendingForSubmittedApplicationList'
  import SubmittedApplicationList from './pages/SubmittedApplicationList'
  import ChangeApplLists from './pages/ChangeReqApplicationList'
  //import ReviewedApplicationList from './pages/ReviewedApplicationList'
  import { ME } from '../graphql/userinfo'
  import {mapGetters} from 'vuex'

  export default {
    data() {
      return {
        userInfo: {
          ekyc:{
            status:''
          }
        },
        colorx:'success'
      }
    },
    components: {
      Guarantor,
      ApplicationList,
      InProgressApplicationList,
      HaltApplicationList,
      AcceptedApplicationList,
      RejectedtedApplicationList,
      SearchApplicationList,
      PendingForSubmittedApplicationList,
      SubmittedApplicationList,
      ChangeApplLists
      //ReviewedApplicationList,
    },
    apollo: {
      user: {
        query: ME,
        manual: true,
        result ({ data, loading }) {
          if (!loading) {
            this.userInfo = data.me
            //console.log("MeeeeeeDasfff", this.userInfo);
          }
        }
      }
    },

    created(){
      this.$apollo.queries.user.refetch();
      console.log("Meeeeee refetch", this.userInfo);
      this.$store.dispatch('getChangeReqApplLists', `9/${this.userInfo.id}`);
    },
    computed: {
      ...mapGetters(['allChangeReqAppl'])
    },
    methods : {
      addGuarantor (){
        this.$router.push('/guarantorInfo').catch(() => {})
      },
      goToPurches(){
        this.$router.push('/purchaseApplication').catch(() => {})
      }
    }
  }
</script>
